import { mercuryApi } from '$api'
import { PayClassification, transformPayClassificationOnGet } from '$models'
import sortBy from 'lodash/sortBy'

/**
 * Get all Pay Classifications
 * @returns Promise<PayClassification[]>
 */
export const getAll = async (): Promise<PayClassification[]> => {
  const result = await mercuryApi.get<PayClassification[]>(
    '/pay-classifications'
  )
  const transformedPayClassifications = result.map(
    transformPayClassificationOnGet
  )
  return sortBy<PayClassification>(transformedPayClassifications, 'name')
}
